export const ComptrollerAbi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'getAssetsIn',
    outputs: [
      {
        internalType: 'contract CToken[]',
        name: '',
        type: 'address[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'closeFactorMantissa',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'liquidationIncentiveMantissa',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  // Per-market pause guardians. Classic Compound V2 keeps them as public
  // mappings on the Comptroller — the cToken lenses do NOT expose them, so a
  // fork on the standard lens path can only learn its pause state from here.
  // `mintAllowed` / `borrowAllowed` hard-revert ("mint is paused" /
  // "borrow is paused") when set, which is why they gate `depositsEnabled` /
  // `borrowingEnabled` rather than merely capping an amount.
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'mintGuardianPaused',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'borrowGuardianPaused',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
] as const
